import {isNil} from 'lodash-es';
import React, {FC, useRef, ChangeEvent} from 'react';

import {postUploadFile} from 'features/configure-table-report-actions-menu/api/api';
import {showMessageFromResponse} from 'shared/utils';
import {showRequestErrorMessage} from 'shared/utils/show-message-from-response';

import {IReportConfigurationAction} from '../../model/types';

interface IUploadFileActionProps {
  action: IReportConfigurationAction;
  docId: string | null;
  templateCode: string | undefined;
  handleRefreshReportPage?: () => void;
}

export const UploadFileAction: FC<IUploadFileActionProps> = ({
    action,
    docId,
    templateCode,
    handleRefreshReportPage,
    ...props
}: IUploadFileActionProps) => {
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
        const input = event.target;
        const file = event.target.files?.[0];

        if (!file) return;

        try {
            const response = await postUploadFile({
                action: action.action,
                ...(!isNil(docId) && {docId}),
                templateCode,
                files: [file],
            });
            showMessageFromResponse({response});
            handleRefreshReportPage?.();
        } catch (error) {
            showRequestErrorMessage(error);
        } finally {
            input.value = '';
        }
    };

    return (
        <>
            <span
                {...props}
                onClick={handleClick}
            >
                {action?.meaning || 'Загрузить файл'}
            </span>
            <input
                type="file"
                ref={fileInputRef}
                style={{display: 'none'}}
                onChange={handleFileChange}
                accept=".xls,.xlsx"
            />
        </>
    );
};
